import { Box, Button, Dialog, Stack, Typography } from "@mui/material";

import { theme } from "../../../../../assets";
import { TUser } from "./collabs-equip-edit";

export const DeleteUserDialog = ({
    handleClose,
    open,
    removeTeamUser,
    selectedUser,
}: {
    handleClose: () => void;
    open: boolean;
    selectedUser: TUser;
    removeTeamUser: (id: string) => void;
}) => {
    return (
        <Dialog
            open={open}
            sx={{
                ".MuiDialog-paper": {
                    width: "100%",
                    maxWidth: "36.6875rem",
                    overflowY: "unset",
                },
            }}
        >
            <Box
                sx={{
                    p: "1rem",
                    width: "100%",
                }}
            >
                <Stack
                    sx={{
                        gap: "0.75rem",
                        px: "1.5rem ",
                        marginTop: "1vh",
                    }}
                >
                    <Typography variant="h6">Excluir colaborador</Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: theme.gray500,
                        }}
                    >
                        Deseja remover este colaborador do projeto?
                    </Typography>
                </Stack>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "1rem",
                    }}
                >
                    <Button variant="text" onClick={handleClose}>
                        CANCELAR
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => removeTeamUser(selectedUser.id_e)}
                    >
                        EXCLUIR
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};
